export default "__VITE_ASSET__42cd83af__"